import { atom } from 'recoil';

import { group, identify } from '../../services/analytics';
import { USER_INFO } from '../../utils/constants/localStorage';
import { getLocalStorageObject, setLocalStorageObject } from '../../utils/functions/localStorage';

export type UserStateTypes = {
  company: string;
  country: string;
  mfa: boolean;
  name: string;
  profile_image: string;
  surname: string;
  user_id: string;
  email: string;
  calyx_team: boolean;
  project_access_type: string;
  user_permissions: string[];
  user_roles: string[];
  user_category: string;
  credit_retirement_volume: string;
  company_type: string;
  subscription_end_date: string;
  compass_modules_access: string[];
  ratings_access_type: string;
  user_type: string;
  compass_access_type: string;
} | null;
export const USER_STATE_KEY = 'user_state';

export const userState = atom<UserStateTypes>({
  key: USER_STATE_KEY,
  default: getLocalStorageObject(USER_INFO),
  effects: [
    ({ onSet }) => {
      onSet((userState) => {
        setLocalStorageObject(USER_INFO, userState);

        // If user data exists, identify the user in analytics systems
        if (userState?.email) {
          // Identify the user in all analytics platforms, including HubSpot
          identify(`${userState.email}`, userState);

          // Group by company if available
          if (userState.company) {
            group('company', {
              name: userState.company,
            });
          }
        }
      });
    },
  ],
});

export const REDIRECTION_URL_STATE_KEY = 'redirection_url_state_key';
export const redirectionURLState = atom<string>({
  key: REDIRECTION_URL_STATE_KEY,
  default: '/',
});
